import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import {connect} from 'react-redux';

const LOGIN_PATH = '/login';

const AuthRoute = ({component, ...props}) => {
  const { isPublic } = component;
  const isAuthenticated = (props.token && props.token.length)
  if (isAuthenticated || isPublic) {
    return <Route { ...props } component={ component } />;
  } else {
    return <Redirect to={ LOGIN_PATH } />;
  }
};

function mapStateToProps(state) {
  const token = state.authentication.token;
  return {
    token: token,
  };
}

export default connect(mapStateToProps)(AuthRoute);



// WEBPACK FOOTER //
// ./src/AuthRoute.js